module.exports = {"top":"Top :item","item":":item","errors":{"noItemFound":"No :item found!","nothingFound":"Nothing found!"}};